import React from "react";
import { Container, Row, Col } from "react-bootstrap/";
import "./Education.css";
import education from "../images/education_darkb.svg";
import { useInView } from "react-intersection-observer";

function Education() {
  const { ref: educationRef, inView: educationVisible } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const engineeringAchievements = [
    { title: "Woitas Family Leaders Scholarship", year: "2024" },
    { title: "WESCO Student Achievement Award", year: "2022" },
    { title: "Schulich Engineering Dean's List", year: "2019-2022" },
    { title: "Jason Lang Scholarship Recipient", year: "2020-2022" },
    { title: "President's Admission Scholarship", year: "2019" },
  ];

  const businessAchievements = [
    { title: "HSBC Bank Canada International Business Award", year: "2024" },
    { title: "Haskayne School of Business Dean's List", year: "2019-2024" },
    { title: "Michael W. Johnson Memorial Scholarship", year: "2022" },
    { title: "Distinguished Business Leader Award", year: "2021" },
  ];

  return (
    <Container fluid className="educationSection py-5" id="education" ref={educationRef}>
      <Container className={`${educationVisible ? "fade-in-up" : "opacity-0"}`}>
        <div className="section-header text-center">
          <h2 className="section-title">Education</h2>
          <div className="titleHr" />
          <p className="section-subtitle">
            University of Calgary &bull; Combined Dual Degree (09/2019 - 06/2025)
          </p>
        </div>

        <Row className="g-4 align-items-center mb-4">
          <Col xs={12} lg={4} className="text-center">
            <div className="educationImgCard glass-card p-4">
              <img
                loading="lazy"
                className="educationImg img-fluid"
                src={education}
                alt="University Education"
              />
              <div className="degreeHeaderBadge mt-3">
                <span className="degreeUni">University of Calgary</span>
                <span className="degreeTimeline">2019 - 2025</span>
              </div>
            </div>
          </Col>

          <Col xs={12} lg={8}>
            <Row className="g-4">
              {/* Software Engineering Degree Card */}
              <Col xs={12} md={6}>
                <div className="glass-card degreeCard h-100 p-4">
                  <div className="degreeTypeTag badge-pill-cyan">
                    <span>💻 B.Sc. Degree</span>
                  </div>
                  <h3 className="degreeTitle">Software Engineering</h3>
                  <div className="institutionName">Schulich School of Engineering</div>
                  
                  <div className="achievementsHeader mt-3">Scholarships &amp; Honors:</div>
                  <ul className="achievementList">
                    {engineeringAchievements.map((item, idx) => (
                      <li key={idx} className="achievementItem">
                        <span className="achievementBullet">&bull;</span>
                        <div>
                          <span className="achievementName">{item.title}</span>
                          <span className="achievementYear"> ({item.year})</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              {/* Business Degree Card */}
              <Col xs={12} md={6}>
                <div className="glass-card degreeCard h-100 p-4">
                  <div className="degreeTypeTag badge-pill-purple">
                    <span>📊 B.Com Degree</span>
                  </div>
                  <h3 className="degreeTitle">Business</h3>
                  <div className="institutionName">Haskayne School of Business</div>
                  
                  <div className="achievementsHeader mt-3">Scholarships &amp; Honors:</div>
                  <ul className="achievementList">
                    {businessAchievements.map((item, idx) => (
                      <li key={idx} className="achievementItem">
                        <span className="achievementBullet">&bull;</span>
                        <div>
                          <span className="achievementName">{item.title}</span>
                          <span className="achievementYear"> ({item.year})</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Education;
